export default __webpack_public_path__ + "static/media/export.16af35c6.svg";